import React from 'react';
import PropTypes from 'prop-types';

class ContextPathProvider extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        contextPath: PropTypes.string.isRequired,
    };

    static childContextTypes = {
        contextPath: PropTypes.string,
    };

    getChildContext = () => ({
        contextPath: this.props.contextPath,
    });

    render() {
        return this.props.children;
    }
}

export default ContextPathProvider;



// WEBPACK FOOTER //
// ./src/frontend/components/contextpath/ContextPathProvider.jsx